import ScreenLoading from '../../../../../shared/components/ScreenLoading'
import CustomSnackBar from '../../../../../shared/components/CustomSnackBar'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'

export function UserDetailNotifications() {
  const { error, msg, loading } = useSelector((state: IRootState) => state.user)

  return (
    <>
      <ScreenLoading loadings={[loading]} />
      <CustomSnackBar errors={[error]} msgs={[msg]} />
    </>
  )
}
